window.DACLocalization = {
    records() {
        const source = document.getElementById('country-list-template');
        const records = source?.content.querySelector('[data-country-records]');
        return records ? JSON.parse(records.content.textContent) : [];
    },
    attach(form, panel, records, apply) {
        const input = form.querySelector('[name="country_code"]');
        const language = panel.querySelector('[data-localization-language]');
        const button = panel.querySelector('[data-localization-apply]');
        if (!input || !language || !button) return null;
        const originalCountry = input.value;
        const originalLanguage = language.value;
        const originalLanguages = Array.from(language.options, option => [option.value, option.textContent]);
        let preferredLanguage = originalLanguage;
        let applying = false;
        const select = code => {
            const country = records.find(row => row[0] === code);
            if (!country) return;
            input.value = code;
            const languages = country[6]?.length ? country[6] : originalLanguages;
            language.replaceChildren(...languages.map(([value, name]) => {
                const option = document.createElement('option');
                option.value = value;
                option.lang = value;
                option.textContent = name;
                return option;
            }));
            language.value = languages.some(row => row[0] === preferredLanguage) ? preferredLanguage : (languages[0]?.[0] || originalLanguage);
            const flag = panel.querySelector('[data-localization-flag]');
            if (flag) flag.src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg';
            const name = panel.querySelector('[data-localization-country]');
            if (name) name.textContent = country[1];
            const currency = panel.querySelector('[data-localization-currency]');
            if (currency) currency.textContent = country[2] + ' ' + country[3];
            panel.querySelectorAll('a[data-value], button[data-code]').forEach(option => {
                const selected = (option.dataset.value || option.dataset.code) === code;
                option.classList.toggle('is-current', selected);
                if (selected) option.setAttribute('aria-current', 'true');
                else option.removeAttribute('aria-current');
            });
        };
        language.addEventListener('change', () => { preferredLanguage = language.value; });
        button.addEventListener('click', () => {
            if (applying) return;
            applying = true;
            apply(input.value !== originalCountry, language.value !== originalLanguage);
        });
        return {select, reset() { applying = false; preferredLanguage = originalLanguage; select(originalCountry); }};
    }
};


window.DACCountrySelector = function() {
    if (customElements.get('localization-form')) return;

    class LocalizationForm extends HTMLElement {
        connectedCallback() {
            if (this.initialized) return;
            this.initialized = true;
            this.elements = {
                input: this.querySelector('input[name="country_code"]'),
                button: this.querySelector('.disclosure__button'),
            };
            this.elements.button?.addEventListener('click', () => this.openSelector());
            this.addEventListener('keydown', event => this.onContainerKeyUp(event));
            this.addEventListener('focusout', event => {
                if (event.relatedTarget && !this.contains(event.relatedTarget)) this.hidePanel();
            });
        }

        disconnectedCallback() {
            document.removeEventListener('pointerdown', this.outsideClick);
        }

        initPanel() {
            if (this.elements.panel) return;
            const template = this.querySelector('[data-country-template]') || this.querySelector('#country-list-template');
            const dataTemplate = document.getElementById('country-list-template');
            const panel = this.querySelector('.dac-country-panel') || template.content.querySelector('.dac-country-panel').cloneNode(true);
            const records = template.content.querySelector('[data-country-records]') || dataTemplate?.content.querySelector('[data-country-records]');
            if (records && !panel.querySelector('li[data-country]')) {
                const rowTemplate = template.content.querySelector('[data-country-row]');
                const fragment = document.createDocumentFragment();
                const nameText = document.createElement('textarea');
                JSON.parse(records.content.textContent).forEach(([code, name, currency, symbol, ddp, current]) => {
                    const row = rowTemplate.content.firstElementChild.cloneNode(true);
                    row.dataset.country = name;
                    row.dataset.currency = currency;
                    const link = row.querySelector('a');
                    link.dataset.value = code;
                    if (ddp) link.dataset.ddp = 'true';
                    if (current) link.setAttribute('aria-current', 'true');
                    const flag = row.querySelector('img');
                    flag.src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg';
                    flag.alt = name;
                    nameText.innerHTML = name;
                    row.querySelector('.dac-country-name').textContent = nameText.value;
                    row.querySelector('[data-country-currency]').replaceWith(document.createTextNode(currency));
                    const symbolLabel = row.querySelector('[data-country-symbol]');
                    symbolLabel.textContent = symbol + ')';
                    symbolLabel.removeAttribute('data-country-symbol');
                    fragment.append(row);
                });
                panel.querySelector('.dac-country-options ul').append(fragment);
            }
            this.localizer = window.DACLocalization.attach(this.querySelector('form'), panel, records ? JSON.parse(records.content.textContent) : [], (countryChanged, languageChanged) => {
                if (countryChanged) {
                    const selected = panel.querySelector('a[data-value="' + this.elements.input.value + '"]');
                    if (selected) this.applyCountry(selected);
                } else if (languageChanged) {
                    this.querySelector('form').submit();
                }
                this.hidePanel();
            });
            this.elements.panel = panel;
            if (!panel.isConnected) template.after(panel);
            const suffix = ++LocalizationForm.panelId;
            panel.id = 'CountryList-' + suffix;
            panel.querySelector('h2').id = 'dac-country-heading-' + suffix;
            panel.setAttribute('aria-labelledby', panel.querySelector('h2').id);
            this.elements.button.setAttribute('aria-controls', panel.id);
            this.elements.search = panel.querySelector('[data-country-search]');
            this.elements.search.id = 'country-list-search-input-' + suffix;
            panel.querySelector('label').htmlFor = this.elements.search.id;
            this.elements.rows = [...panel.querySelectorAll('li[data-country]')];
            this.elements.clear = panel.querySelector('[data-country-clear]');
            panel.querySelectorAll('a[data-value]').forEach(item => item.addEventListener('click', event => this.onItemClick(event)));
            panel.querySelector('[data-country-close]').addEventListener('click', () => { this.hidePanel(); this.elements.button.focus(); });
            this.elements.clear.addEventListener('click', () => { this.elements.search.value = ''; this.filterCountries(); this.elements.search.focus(); });
            this.elements.search.addEventListener('input', () => this.filterCountries());
            this.outsideClick = event => { if (!this.contains(event.target)) this.hidePanel(); };
        }

        filterCountries() {
            const query = this.elements.search.value.trim().toLocaleLowerCase();
            let count = 0;
            this.elements.rows.forEach(row => {
                row.hidden = !(row.dataset.country + ' ' + row.dataset.currency).toLocaleLowerCase().includes(query);
                if (!row.hidden) count++;
            });
            this.elements.clear.hidden = !this.elements.search.value;
            const countLabel = this.elements.panel.querySelector('[data-country-count]');
            countLabel.textContent = count + ' ' + (count === 1 ? countLabel.dataset.countOne : countLabel.dataset.countLabel);
            this.elements.panel.querySelector('[data-country-empty]').hidden = count !== 0;
            this.elements.panel.querySelector('.dac-country-options').scrollTop = 0;
        }

        hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            if (this.elements.panel) this.elements.panel.hidden = true;
            document.removeEventListener('pointerdown', this.outsideClick);
        }

        onContainerKeyUp(event) {
            if (event.key !== 'Escape' || !this.elements.panel || this.elements.panel.hidden) return;
            event.preventDefault();
            event.stopPropagation();
            this.hidePanel();
            this.elements.button.focus();
        }

        onItemClick(event) {
            event.preventDefault();
            if (this.localizer) { this.localizer.select(event.currentTarget.dataset.value); return; }
            this.applyCountry(event.currentTarget);
        }

        applyCountry(selected) {
            const selectedValue = this.elements.button.querySelector('.country-selector__content');
            this.elements.input.value = selected.dataset.value;
            selectedValue.innerHTML = selected.querySelector('.country-selector__content').innerHTML;

            if (!selected.dataset.ddp) {
                document.body.classList.add('ddu-country');
            }

            try { localStorage.setItem('dac-locale-code', selected.dataset.value); } catch (_) {}

            this.openWelcomePopup();

            this.hidePanel();
        }

        openWelcomePopup(useFallback = false) {
            const form = this.querySelector('form');
            if (!useFallback) {
                const request = new CustomEvent('dac:country-welcome', {
                    cancelable: true,
                    detail: {
                        countryCode: this.elements.input.value,
                        languageCode: form.querySelector('[name="language_code"]')?.value,
                        onDismiss: () => form.submit(),
                        onUnavailable: () => this.openWelcomePopup(true)
                    }
                });
                if (!document.dispatchEvent(request)) {
                    this.closest('.country-popup')?.remove();
                    return;
                }
            }
            if (this.closest('.country-popup')) { form.submit(); return; }
            const template = document.getElementById('country-popup-template');
            const popup = template.content.querySelector('.country-popup').cloneNode(true);

            const countryName = this.elements.button.querySelector('img').alt;

            const step1 = popup.querySelector('.country-popup__box-step-1');
            const step2 = popup.querySelector('.country-popup__box-step-2');

            step1.querySelector('.country-popup__title').textContent = `Te damos la bienvenida a ${countryName}`;

            const shopButton = popup.querySelector('.country-popup__button-shop');
            const step2Button = popup.querySelector('.country-popup__button-step-2');

            shopButton.addEventListener('click', () => form.submit());
            popup.querySelectorAll('.country-popup__button-close').forEach(function(el) {
                el.addEventListener('click', () => form.submit());
            });

            step2Button.addEventListener('click', () => {
                const localizationForm = this.cloneNode(true);
                localizationForm.querySelector('.disclosure').classList.remove('country-selector__flag-only');
                step2.appendChild(localizationForm);
                step1.style.display = 'none';
                step2.style.display = 'block';
            });

            template.after(popup);
        }
    
        openSelector() {
            this.initPanel();
            if (!this.elements.panel.hidden) { this.hidePanel(); return; }
            this.localizer?.reset();
            this.elements.search.value = '';
            this.filterCountries();
            this.elements.panel.hidden = false;
            this.elements.button.setAttribute('aria-expanded', 'true');
            document.addEventListener('pointerdown', this.outsideClick);
            this.elements.panel.querySelector('[data-country-close]').focus({preventScroll: true});
        }
    }
    LocalizationForm.panelId = 0;
    customElements.define('localization-form', LocalizationForm);
};
